import type { SocialImageCandidate } from 'lib/seo/socialImage'
import { getContentfulHeroImageIds } from './getContentfulHeroImageIds'

export function getContentfulSocialImage(page: App.ContentfulWebPageData): SocialImageCandidate | undefined {
  if (page.socialImageId?.trim()) {
    return { id: page.socialImageId, alt: page.socialImageAlt }
  }
  for (const component of page.components) {
    // Product carousels, logos and modal imagery do not represent the whole page.
    const id = component.contentTypeId === 'componentHeroImage' && component.title
      ? getContentfulHeroImageIds(component).desktopId
      : component.contentTypeId === 'componentCampaignHero' ? component.backGroundImage.id : undefined
    if (id?.trim()) return { id }
  }
  return undefined
}
